import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { useCssVars as _useCssVars } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "search"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "newstop"
};
const _hoisted_7 = {
  style: {
    "padding": "14px"
  }
};
const _hoisted_8 = {
  class: "bottom"
};
const _hoisted_9 = {
  class: "time"
};
const _hoisted_10 = {
  style: {
    "padding": "14px"
  }
};
const _hoisted_11 = {
  class: "bottom"
};
const _hoisted_12 = {
  class: "tab_time"
};
import { Search } from '@element-plus/icons-vue';
import { ref, onMounted, computed, onBeforeUnmount, onActivated, onDeactivated } from 'vue';
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
import { useRouter } from 'vue-router';
// import gsap from 'gsap'

export default {
  __name: 'News',
  setup(__props) {
    _useCssVars(_ctx => ({
      "v31388e80": divHeight.value - 50 + 'px'
    }));
    const router = useRouter();
    const SearchText = ref('');
    const fyscreen = ref(18);
    // const visible = ref(false)
    const newsList = ref([]);
    const divHeight = ref();
    moment.locale('zh-cn');
    const whichTab = ref(1);
    const tablist = [{
      label: '最新动态',
      name: 1
    }, {
      label: '典型案例',
      name: 2
    }, {
      label: '方允时空',
      name: 3
    }];
    const handleOrientationChange = () => {
      var isLandscape = window.matchMedia("(orientation: landscape)").matches;
      fyscreen.value = isLandscape ? 18 : 24;
    };
    const onResize = () => {
      divHeight.value = 0.47 * window.innerWidth;
    };
    onActivated(() => {

      // 调用时机为首次挂载
      // 以及每次从缓存中被重新插入时
      // console.log("this is first")
    });
    onDeactivated(() => {
      window.removeEventListener('orientationchange', handleOrientationChange);

      // 在从 DOM 上移除、进入缓存
      // 以及组件卸载时调用
      console.log("this is second");
    });
    onMounted(async () => {
      divHeight.value = 0.47 * window.innerWidth;
      var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) && window.orientation === 0;
      fyscreen.value = flag ? 24 : 18;
      window.addEventListener('orientationchange', handleOrientationChange);
      window.addEventListener('resize', onResize);
      var res = await axios.get('/webapi/news/list');

      // console.log('Request URL:', res.config.url);  // 打印请求 URL
      // console.log(res.data.data)
      newsList.value = res.data.data;
      // console.log(_.groupBy(newsList.value, (item) => item.category))
    });

    // function onBeforeEnter(el) {
    //   el.style.opacity = 0
    //   el.style.height = 0
    // }

    // function onEnter(el, done) {
    //   gsap.to(el, {
    //     opacity: 1.0,
    //     height: '1.6em',
    //     delay: el.dataset.index * 0.15,
    //     onComplete: done
    //   })
    // }

    // function onLeave(el, done) {
    //   gsap.to(el, {
    //     opacity: 0,
    //     height: 0,
    //     delay: el.dataset.index * 0.15,
    //     onComplete: done
    //   })
    // }

    onBeforeUnmount(() => {
      window.removeEventListener('orientationchange', handleOrientationChange);
      window.removeEventListener('resize', onResize);
    });
    const searchnewslist = computed(() => SearchText.value ? newsList.value.filter(item => item.title.includes(SearchText.value)) : []);
    const visible = computed({
      get() {
        return SearchText.value ? true : false;
      },
      set() {}
    });
    const newstoplst = computed(() => newsList.value.slice(0, 4));
    const formatTime = time => {
      return moment(time).format('lll');
    };
    const tabnews = computed(() => _.groupBy(newsList.value, item => item.category));
    const handleChangePage = id => {
      router.push({
        path: `/news/${id}`
      });
      // console.log(id)
    };
    const handleBlur = () => {
      setTimeout(() => {
        // visible = false;
        SearchText.value = '';
      }, 200);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_timeline_item = _resolveComponent("el-timeline-item");
      const _component_el_timeline = _resolveComponent("el-timeline");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_backtop = _resolveComponent("el-backtop");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "news-header",
        style: _normalizeStyle({
          backgroundImage: `url(${require('../assets/p001.jpg')})`,
          height: divHeight.value + 'px'
        })
      }, null, 4), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_popover, {
        placement: "bottom",
        title: "检索结果",
        width: "50%",
        visible: visible.value
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: SearchText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => SearchText.value = $event),
          class: "searchcontent",
          placeholder: "请输入搜索的新闻",
          "prefix-icon": _unref(Search),
          type: "search",
          size: "large",
          onInput: _cache[1] || (_cache[1] = $event => visible.value = true),
          onBlur: handleBlur
        }, null, 8, ["modelValue", "prefix-icon"])]),
        default: _withCtx(() => [_createVNode(_TransitionGroup, {
          name: "fade",
          appear: ""
        }, {
          default: _withCtx(() => [searchnewslist.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchnewslist.value, data => {
            return _openBlock(), _createElementBlock("div", {
              key: data._id,
              class: "searchnewslist_div",
              onClick: $event => handleChangePage(data._id)
            }, _toDisplayString(data.title), 9, _hoisted_4);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_empty, {
            description: "暂无检索结果",
            "img-size": 50
          })]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["visible"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newstoplst.value, item => {
          return _openBlock(), _createBlock(_component_el_col, {
            span: 6,
            key: item._id
          }, {
            default: _withCtx(() => [_createVNode(_component_el_card, {
              "body-style": {
                padding: '0px'
              },
              shadow: "hover",
              onClick: $event => handleChangePage(item._id)
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "news_img",
                style: _normalizeStyle({
                  backgroundImage: `url(https://www.fomyom.com/fyimg${item.cover})`
                })
              }, null, 4), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("time", _hoisted_9, _toDisplayString(formatTime(item.editTime)), 1)])])]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]), _createVNode(_component_el_tabs, {
        modelValue: whichTab.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => whichTab.value = $event),
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tablist, item => {
          return _createVNode(_component_el_tab_pane, {
            label: item.label,
            name: item.name,
            key: item.name
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              gutter: 20
            }, {
              default: _withCtx(() => [_createVNode(_component_el_col, {
                span: fyscreen.value
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabnews.value[item.name], data => {
                  return _openBlock(), _createElementBlock("div", {
                    key: data._id,
                    style: {
                      "padding": "10px"
                    }
                  }, [_createVNode(_component_el_card, {
                    "body-style": {
                      padding: '0px'
                    },
                    shadow: "hover",
                    onClick: $event => handleChangePage(data._id)
                  }, {
                    default: _withCtx(() => [_createElementVNode("div", {
                      class: "tab_news_img",
                      style: _normalizeStyle({
                        backgroundImage: `url(https://www.fomyom.com/fyimg${data.cover})`
                      })
                    }, null, 4), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(data.title), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("time", _hoisted_12, _toDisplayString(formatTime(data.editTime)), 1)])])]),
                    _: 2
                  }, 1032, ["onClick"])]);
                }), 128))]),
                _: 2
              }, 1032, ["span"]), _createVNode(_component_el_col, {
                span: 24 - fyscreen.value
              }, {
                default: _withCtx(() => [_createVNode(_component_el_timeline, {
                  class: "fytime"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabnews.value[item.name], (data, index) => {
                    return _openBlock(), _createBlock(_component_el_timeline_item, {
                      key: index,
                      timestamp: formatTime(data.editTime)
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(data.title), 1)]),
                      _: 2
                    }, 1032, ["timestamp"]);
                  }), 128))]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["span"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["label", "name"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_backtop, {
        right: 30,
        bottom: 30
      })]);
    };
  }
};